import React, { useState, useEffect } from "react";
import Logo from "../../images/logo1.png";
import layout from "../../css/landing.module.css";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import styles from "../../css/viewmembers.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";

import {
  faUser,
  faHouse,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

function Attendancefaith() {

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  const perPage = 10;

  // FETCH ATTENDANCE
  useEffect(() => {
    fetchAttendance();
  }, []);

  const fetchAttendance = async () => {

    try {

      const response = await axios.get(
        "https://appserver.cemkharistemple.com/faithattendance"
      );

      setData(response.data);

    } catch (error) {

      console.error("Error fetching attendance:", error);

    }

  };

  // SEARCH
  const filteredData = data.filter((row) =>
    row.service_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    row.service_date.toLowerCase().includes(searchTerm.toLowerCase()) ||
    row.male.toString().includes(searchTerm) ||
    row.female.toString().includes(searchTerm) ||
    row.first_timers.toString().includes(searchTerm) ||
    row.total_count.toString().includes(searchTerm)
  );

  // PAGINATION
  const pageCount = Math.ceil(filteredData.length / perPage);
  const offset = currentPage * perPage;

  const currentPageData = filteredData.slice(
    offset,
    offset + perPage
  );

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  // LOGOUT
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (

    <div className={layout.container}>

      {/* HEADER */}

      <Topbar title="Faith Attendance" subtitle="Service statistics" />

      {/* SIDEBAR */}

      <Sidebar variant="faith" />

      {/* MAIN */}

      <main className={layout.main}>

        <div className={styles.wrapper}>

          <div className={styles.card}>

            <div className={styles.cardHeader}>
              <h3>Search Attendance</h3>
              <span>(Service Type, Date or Count)</span>
            </div>

            <input
              type="text"
              placeholder="Search attendance..."
              value={searchTerm}
              onChange={(e) => {

                setSearchTerm(e.target.value);
                setCurrentPage(0);

              }}
              className={styles.searchbar}
            />

            <div className={styles.tableContainer}>

              <table className={styles.table}>

                <thead>
                  <tr>
                    <th>#</th>
                    <th>Service Type</th>
                    <th>Date</th>
                    <th>Male</th>
                    <th>Female</th>
                    <th>First Timers</th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>

                  {currentPageData.length > 0 ? (

                    currentPageData.map((row, index) => (

                      <tr key={index}>

                        <td>{offset + index + 1}</td>
                        <td>{row.service_type}</td>
                        <td>{row.service_date}</td>
                        <td>{row.male}</td>
                        <td>{row.female}</td>
                        <td>{row.first_timers}</td>
                        <td>{row.total_count}</td>

                      </tr>

                    ))

                  ) : (

                    <tr>
                      <td colSpan="7" className={styles.noData}>
                        No attendance records found
                      </td>
                    </tr>

                  )}

                </tbody>

              </table>

            </div>

            {/* PAGINATION */}

            <div className={styles.pagination}>

              <ReactPaginate
                previousLabel={"Prev"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                containerClassName={styles.pagination}
                activeClassName={styles.activePage}
              />

            </div>

          </div>

        </div>

      </main>

    </div>

  );
}

export default Attendancefaith;